module.exports = __webpack_public_path__ + "static/media/ml1.62f3f698.jpg";